module.exports = __webpack_public_path__ + "img/document-emptystate.10288586.png";